import { render } from "./PetHeader.vue?vue&type=template&id=e660ea96&scoped=true"
import script from "./PetHeader.vue?vue&type=script&lang=js"
export * from "./PetHeader.vue?vue&type=script&lang=js"

import "./PetHeader.vue?vue&type=style&index=0&id=e660ea96&scoped=true&lang=sass"
import "./PetHeader.vue?vue&type=style&index=1&id=e660ea96&lang=sass"

import exportComponent from "/home/ppfernandez/vuejs/vue-pwa-petinder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e660ea96"]])

export default __exports__